import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterUsersValue,
  UniversalFilterUsersModes,
  UniversalFilterUsersFilterOptions,
  UniversalFilterUsersOnChange
} from './UniversalFilterUsers.types';

import { useUniversalFilterUsers } from './hooks/useUniversalFilterUsers';

import { UsersMultiSelect } from '../../../../../main/users/helpers/UsersMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterUsersProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterUsersValue;
  i18nName: I18nText;
  options?: UniversalFilterUsersFilterOptions;
  autoFocus?: boolean;
  onChange: UniversalFilterUsersOnChange;
}

function UniversalFilterUsers({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  options,
  autoFocus,
  onChange
}: UniversalFilterUsersProps) {
  const { modeOptions, filterState, handleModeChange, handleUserIdsChange } =
    useUniversalFilterUsers({ filterStateCacheKey, filterValue, onChange });

  return (
    <UniversalFilterTemplate<UniversalFilterUsersModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [
          UniversalFilterUsersModes.CONTAINS_ANY_OF
          // UniversalFilterUsersModes.DOES_NOT_CONTAIN_ANY_OF
        ],
        filterState.mode
      ) ? (
        <UsersMultiSelect
          value={filterState.userIds || []}
          initialFilters={options?.initialUsersFilters}
          withoutRecentUsers={options?.withoutRecentUsers}
          autoFocus={autoFocus}
          inputWrapperClassName="block"
          onChange={handleUserIdsChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterUsers;
